import * as Yup from 'yup';
import type { payloadType } from '@/hooks/tracking/useLazyTrack';
import { ActorTypeEnum, SourceEnum, VerbEnum } from './enums';

const ACTOR_TYPES = Object.values(ActorTypeEnum);

const SOURCES = Object.values(SourceEnum);

const VERBS = Object.values(VerbEnum);

const VALIDATION_SCHEMA = Yup.object({
  verb: Yup.string().oneOf(VERBS).required(),
  actor: Yup.object({
    user_id: Yup.string().optional(),
    type: Yup.string().oneOf(ACTOR_TYPES).optional(),
  }).required(),
  context: Yup.object({
    source: Yup.string().oneOf(SOURCES).optional(),
  }).optional(),
  url: Yup.string().optional(),
  path: Yup.string().optional(),
}).required();

function isValidPayload(payload: payloadType): boolean {
  try {
    VALIDATION_SCHEMA.validateSync(payload, { strict: true });
    return true;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('[track] Invalid track payload', error);
    }

    return false;
  }
}

export default isValidPayload;
